// src/plotly-shim.ts
// This shim allows us to use Plotly from a CDN while keeping standard imports
// in our components like: import Plotly from 'plotly.js'

const Plotly = (window as any).Plotly;

if (!Plotly) {
  console.warn('Plotly not found on window object. Ensure the CDN script is loaded in index.html');
}

export default Plotly;

